<mat-toolbar>
  <button mat-icon-button
          fxHide.gt-sm
          (click)="clickMenu()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="spacer">
  </div>
  <ul class="links"
      fxHide.lt-md>
    <ng-container *ngFor="let item of menuItems; let last = last">
      <ng-container *ngIf="item.visible">
        <li>
          <a *ngIf="!item.externalTarget; else outerLink"
             [routerLink]="item.link"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}"
             class="auth-social__link">{{item.text | translate}}</a>
          <ng-template #outerLink>
            <a class="sidenav-close"
               [href]="item.link"
               [target]="item.externalTarget">
              {{item.text | translate}}
            </a>
          </ng-template>
        </li>
        <li *ngIf="!last">
          <span class="spacer">|</span>
        </li>
      </ng-container>
    </ng-container>
  </ul>
  <div class="spacer"></div>
</mat-toolbar>
